module.exports = __webpack_public_path__ + "media/packs/images/flags/MQ-de9d7df14403d9676ddf07f366b4a332.svg";